var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1265 2C14.3136 2 15.4394 2.52729 16.1994 3.43926L19.0729 6.88746C19.6719 7.60632 20 8.51245 20 9.4482V18C20 20.2091 18.2091 22 16 22H8C5.79086 22 4 20.2091 4 18V6C4 3.79086 5.79086 2 8 2H13.1265ZM12 4H8C6.89543 4 6 4.89543 6 6V18C6 19.1046 6.89543 20 8 20H16C17.1046 20 18 19.1046 18 18V10H17C14.2386 10 12 7.76142 12 5V4ZM17.3966 8H17C15.3431 8 14 6.65685 14 5V4.20083C14.2523 4.32333 14.479 4.49896 14.6629 4.71963L17.3966 8ZM7.5 17C7.5 16.4477 7.94772 16 8.5 16H15C15.5523 16 16 16.4477 16 17C16 17.5523 15.5523 18 15 18H8.5C7.94772 18 7.5 17.5523 7.5 17ZM7.5 13.5C7.5 12.9477 7.94772 12.5 8.5 12.5H15C15.5523 12.5 16 12.9477 16 13.5C16 14.0523 15.5523 14.5 15 14.5H8.5C7.94772 14.5 7.5 14.0523 7.5 13.5Z",
    fill: "#121922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/iconDocument.772d9b1db8d37445846261514e44f1c3.svg";
export { ForwardRef as ReactComponent };